import React from 'react';

import logoNOCN from '../assets/images/logoNOCN.png';
import logoSkillPassword from '../assets/images/logoNOCNSkillPasswordWhite.png';

const Header = () => (
  <header>
    <div className="container">
      <a href="https://cpcs.nocn.org.uk/" target="_blank" rel="noopener noreferrer">
        <img className="logo-first" src={logoNOCN} alt="corporative NOCN logo" />
      </a>
      <a href="https://cpcs.nocn.org.uk/" target="_blank" rel="noopener noreferrer">
        <img className="logo-second" src={logoSkillPassword} alt="corporative NOCN logo" />
      </a>
      <h1>CPCS Operator Card Renewal</h1>
    </div>
  </header>
);
export default Header;
